import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import '@cloudscape-design/global-styles/index.css';
import App from './App';
import AppInitWrapper from './AppInitWrapper';
import { getStage } from './api/client';
import { getAmplifyConfig } from './auth/config';

Amplify.configure(getAmplifyConfig(getStage()));

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <AppInitWrapper>
      <App />
    </AppInitWrapper>
  </React.StrictMode>
);
